import * as Actions from './actions'

import { initialState } from '../store/initialState'

export const UsersReducer = (state = initialState.users, action) => {
  switch (action.type) {
    case Actions.FETCH_PRODUCTS_IN_CART:
      return {
        ...state,
        cart: [...action.payload],
      }
    case Actions.FETCH_PRODUCTS_IN_FAVORITE:
      return {
        ...state,
        favorite: [...action.payload],
      }
    case Actions.SIGN_IN:
      // 防御的プログラミング: payloadに必須フィールドがない場合は更新しない
      if (!action.payload || !action.payload.email || !action.payload.uid) {
        console.warn('SIGN_IN: 不完全なpayloadを受信。stateを更新しません。', action.payload)
        return state
      }
      return {
        ...state,
        ...action.payload,
      }
    case Actions.SIGN_OUT:
      return {
        ...state,
        ...action.payload,
      }
    case Actions.EDIT_USER_PROFILE:
      return {
        ...state,
        // icon_path: action.payload.icon_path,
        // username: action.payload.username
        ...action.payload,
      }
    case Actions.UPDATE_PROFILE:
      return {
        ...state,
        ...action.payload,
      }
    case Actions.UPDATE_USER_STATE:
      return {
        ...state,
        ...action.payload,
      }
    default:
      return state
  }
}
